module.exports = "https://img.xiyuyouxi.com/saas/img/mine_menu6.8acc6503.png";